import { IsOptional } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class LoansDTO {
  @ApiProperty()
  // @MaxLength(7, { message: "Projects id allows maximum 7 characters" })
  //  @Matches(new RegExp("^[a-zA-Z0-9]+$"), '', { message: "Projects Code should not include these Charecters !@#$%^&*()_+{}[]:\";'<>?,./~` " })
  @IsOptional()
  employeeId?: number;
}